import { GET_BU_LIST_URL, GET_GBP_LIST_URL, GET_RACK_TYPE_LIST_URL, GET_RACK_CATEGORY_LIST_URL } from '../../const/APIUrl.js';
import { fetchAPI } from '../../api/GenericFetch.js';
import { Suspense } from 'react';
import { useLoaderData, Await } from 'react-router-dom';
import MstLayoutComponent from '../Components/Master/Layout.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstLayout(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstLayout});
    const dropdownList = useLoaderData();    
    return (        
      <Suspense>
        { <Await resolve={dropdownList}>
          {(dropdownList) => <MstLayoutComponent buList={dropdownList.buList} gbpList={dropdownList.gbpList} 
            rackTypeList={dropdownList.rackTypeList} rackCategoryList={dropdownList.rackCategoryList} pageFunction={pageFunction}/>}
        </Await> }
      </Suspense>
    );
}

export async function loader() {
  const [buList, gbpList, rackTypeList, rackCategoryList] = await Promise.all([
        fetchAPI({url:GET_BU_LIST_URL}),
        fetchAPI({url:GET_GBP_LIST_URL}),
        fetchAPI({url:GET_RACK_TYPE_LIST_URL}),
        fetchAPI({url:GET_RACK_CATEGORY_LIST_URL}),
    ]);
    return {buList, gbpList, rackTypeList, rackCategoryList};
}
